import React from "react";
import { parseDate } from "../../services/api";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/**
 * The months a stay touches, with its nights marked:
 *   retreat nights   — forest
 *   extra nights     — chosen ones in clay, ones still on offer outlined
 * Each marked day is the NIGHT that starts on it; the departure morning
 * is shown but not filled. Purely a picture — the choices are the
 * controls beside it — so it is hidden from screen readers, which get
 * the same facts in words.
 */
const StayCalendar = ({ start, end, before = 0, after = 0, maxBefore = 0, maxAfter = 0 }) => {
  const s = parseDate(start), e = parseDate(end);
  const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
  const offerFrom = ymd(add(s, -maxBefore)), offerTo = ymd(add(e, maxAfter));
  const stayFrom = ymd(add(s, -before)), stayTo = ymd(add(e, after));
  const core = [ymd(s), ymd(e)];

  const months = [];
  for (let m = new Date(add(s, -maxBefore).getFullYear(), add(s, -maxBefore).getMonth(), 1);
    m <= add(e, maxAfter); m = new Date(m.getFullYear(), m.getMonth() + 1, 1)) months.push(m);

  const kind = (day) => {
    if (day >= core[0] && day < core[1]) return "is-core";
    if (day >= stayFrom && day < stayTo) return "is-extra";
    if (day >= offerFrom && day < offerTo) return "is-offer";
    if (day === stayTo) return "is-out";
    return "";
  };

  return (
    <div className="bk-cal" aria-hidden="true">
      {months.map((m) => {
        const days = new Date(m.getFullYear(), m.getMonth() + 1, 0).getDate();
        const cells = [...Array(m.getDay()).fill(null), ...Array.from({ length: days }, (_, i) => new Date(m.getFullYear(), m.getMonth(), i + 1))];
        return (
          <div className="bk-cal-month" key={ymd(m)}>
            <p className="bk-cal-name">{m.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p>
            <div className="bk-cal-grid">
              {WEEKDAYS.map((w) => <span key={w} className="bk-cal-wd">{w[0]}</span>)}
              {cells.map((c, i) => (c ? <span key={i} className={`bk-cal-day ${kind(ymd(c))}`}>{c.getDate()}</span> : <span key={i} />))}
            </div>
          </div>
        );
      })}
      <ul className="bk-cal-key">
        <li><i className="is-core" />Retreat</li>
        {(maxBefore > 0 || maxAfter > 0) && <li><i className="is-extra" />Extra nights</li>}
        {(maxBefore > 0 || maxAfter > 0) && <li><i className="is-offer" />Can be added</li>}
      </ul>
    </div>
  );
};

export default StayCalendar;
